// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"Day_scrollable__kDT9s","row":"Day_row__zm0Wi","col":"Day_col__3BJz6","p":"Day_p__2v8T8"};